import { Divider } from 'antd'
import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { FloatPopover } from '../../FloatPopover'
import { useLinkCardStore } from '../Store/hooks/useStore'

import { CancelLinkButton } from './CancelButton'
import { CopyLinkButton } from './CopyButton'
import { EditLinkButton } from './EditButton'
import { SwitchUrlButton } from './SwitchUrlButton'
import { SwitchTitleButton } from './SwtichTitleButton'
import { VisitLinkButton } from './VisitButton'

const useStyles = createStyles(({ token }) => ({
  toolbar: {
    padding: `${token.paddingXS}px ${token.paddingSM}px`
  }
}))

export const LinkToolbar = () => {
  const { nodeKey, toolbarVisible, formVisible, toggleToolbarVisible } =
    useLinkCardStore(state =>
      pick(state, [
        'nodeKey',
        'toolbarVisible',
        'formVisible',
        'toggleToolbarVisible'
      ])
    )

  const { styles } = useStyles()

  return (
    <FloatPopover
      nodeKey={nodeKey}
      open={toolbarVisible}
      placement='bottomLeft'
      trigger='hover'
      onOpenChange={open => {
        if (!formVisible) {
          toggleToolbarVisible(open)
        }
      }}
    >
      <div className={styles.toolbar}>
        <SwitchUrlButton />
        <SwitchTitleButton />
        <Divider orientation='vertical' />
        <VisitLinkButton />
        <EditLinkButton />
        <CopyLinkButton />
        <CancelLinkButton />
      </div>
    </FloatPopover>
  )
}
